import { z } from 'zod';

const TODAY = new Date();
const MIN_DATE = new Date(2020, 0, 1);

export const ERROR_MESSAGES = {
    requiredPartner: 'Kérem válasszon partnert!',
    invalidPartner: 'Érvénytelen partner kiválasztás!',
    requiredDate: 'Kérem válasszon dátumot!',
    futureDate: 'A dátum nem lehet a jövőben!',
    pastDate: 'A dátum nem lehet 2020 előtti!',
    invalidDateRange: 'A kezdő dátum nem lehet későbbi a záró dátumnál!',
    sameDate: 'A kezdő és záró dátum nem lehet ugyanaz!',
    checkTheFields: 'Kérem ellenőrizze a beviteli mezőket!',
};

export type TigFormValues = {
    partner: string;
    from: Date | null;
    to: Date | null;
};

export const tigSchema = z
    .object({
        partner: z
            .string()
            .min(1, ERROR_MESSAGES.requiredPartner)
            .refine(p => p !== 'please_select', {
                message: ERROR_MESSAGES.invalidPartner,
            }),
        from: z
            .union([
                z.coerce
                    .date()
                    .min(MIN_DATE, { message: ERROR_MESSAGES.pastDate })
                    .max(TODAY, { message: ERROR_MESSAGES.futureDate })
                    .refine(date => date !== null && date instanceof Date, {
                        message: ERROR_MESSAGES.requiredDate,
                    }),
                z.null(),
            ])
            .refine(date => date !== null, {
                message: ERROR_MESSAGES.requiredDate,
            }),
        to: z
            .union([
                z.coerce
                    .date()
                    .min(MIN_DATE, { message: ERROR_MESSAGES.pastDate })
                    .max(TODAY, { message: ERROR_MESSAGES.futureDate })
                    .refine(date => date !== null && date instanceof Date, {
                        message: ERROR_MESSAGES.requiredDate,
                    }),
                z.null(),
            ])
            .refine(date => date !== null, {
                message: ERROR_MESSAGES.requiredDate,
            }),
    })
    .refine(
        data => {
            const from = data.from as Date;
            const to = data.to as Date;
            return from <= to;
        },
        {
            path: ['to'],
            message: ERROR_MESSAGES.invalidDateRange,
        }
    )
    .refine(
        data => {
            const from = data.from as Date;
            const to = data.to as Date;
            return from !== to;
        },
        {
            path: ['to'],
            message: ERROR_MESSAGES.sameDate,
        }
    );
